import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'flex-end',
      },
    },
    percents: {
      color: colorsPalette.white,
      lineHeight: 1.2,
      fontSize: 32,
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: 40,
        marginRight: 9,
      },
    },
    details: {
      color: colorsPalette.gray,
      lineHeight: 1.2,
      fontSize: 16,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        marginBottom: 5,
      },
    },
  });
});

export default useStyles;
